/**
 * Общее поле форм плана агроцикла (ящик работы, добавление работы):
 * переключатель «обязательная / по желанию». Остальные поля — компоненты
 * `astra/ui/forms` (`TextField`, `Select`, `DateRangePicker`).
 */

import { defineMessages } from '../../../i18n/define';
import { useT } from '../../../i18n/hooks';
import { Field, Segmented } from '../../ui/forms';

const m = defineMessages({
  requiredGroup: { id: 'cycle.plan.field.requiredGroup', defaultMessage: 'Обязательность работы', description: 'aria-label переключателя «обязательная / по желанию» в форме работы плана агроцикла (менеджер)' },
  required: { id: 'cycle.plan.field.required', defaultMessage: 'Обязательная', description: 'Вариант переключателя в форме работы плана: работа обязательная; коротко' },
  optional: { id: 'cycle.plan.field.optional', defaultMessage: 'По желанию', description: 'Вариант переключателя в форме работы плана: работа не обязательная; коротко' },
});

/** «Обязательная / По желанию». */
export function RequiredToggle({ value, onChange }: { value: boolean; onChange: (v: boolean) => void }) {
  const t = useT();
  return (
    <Field label={t(m.requiredGroup)}>
      <Segmented
        aria-label={t(m.requiredGroup)}
        value={value ? 'yes' : 'no'}
        onChange={(next) => onChange(next === 'yes')}
        options={[
          { id: 'yes', label: t(m.required) },
          { id: 'no', label: t(m.optional) },
        ]}
      />
    </Field>
  );
}
